



























import { PropType } from 'vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import Spinner from '@/commoncomponents/spinner/Spinner.vue'
import Step, { StepState } from '@/components/familyPortal/checkout/stepper/Step.vue'
import { ScreenText } from '@/lang/ScreenText'
import cart from '@/store/modules/checkout/cart/module'
import APP_CONST from '@/constants/AppConst'
import commonEntry from '@/store/modules/commonEntry'

export enum CheckoutStep {
  Review = 1,
  Apply = 2,
  Submit = 3,
  Done = 4
}

@Component({
  components: {
    Spinner,
    Step
  }
})
export default class Stepper extends Vue {
  public readonly StepState = StepState
  public readonly CheckoutStep = CheckoutStep
  public readonly screenText = new ScreenText()
  public isReloadingCart = false
  APP_CONST = APP_CONST

  @Prop({ type: Number as PropType<CheckoutStep>, required: true })
  readonly activeStep!: CheckoutStep

  get cartHasPrice(): boolean {
    return cart.subtotal > 0
  }

  get designColor(): string {
    return commonEntry.accountDesignDetails.accentColor
  }

  get isLoadingCartApplicationsData(): boolean {
    return cart.isLoadingCartApplicationsData
  }

  get isFetchingCart(): boolean {
    return cart.isFetchingCart || cart.isUpdatingCart || cart.isDeleting
  }

  get currentApplicationDisplay(): number {
    return cart.currentlySelectedApplicationIndex + 1
  }

  get applicationsTotal(): number {
    return cart.cartApplications ? cart.cartApplications.cartItemApplicationData.length : 0
  }

  get submitStepText(): string {
    return this.screenText.getScreenText('CHECKOUT_STEP_SUBMIT')
  }

  public onReloadCartEvent(isReloadingCart: boolean) {
    this.isReloadingCart = isReloadingCart
  }

  public getState(step: CheckoutStep): StepState {
    if (step < this.activeStep) {
      return StepState.Complete
    } else if (step == this.activeStep) {
      if (step == CheckoutStep.Done) {
        // "Done" step is special -- should be marked complete when active.
        return StepState.Complete
      } else {
        return StepState.Active
      }
    } else {
      return StepState.Inactive
    }
  }

  private attachExternalListeners() {
    Vue.prototype.$eventHub.$on(APP_CONST.CART_IS_RELOADING_EVENT, this.onReloadCartEvent)
  }

  private detachExternalListeners() {
    Vue.prototype.$eventHub.$off(APP_CONST.CART_IS_RELOADING_EVENT, this.onReloadCartEvent)
  }

  created() {
    this.attachExternalListeners()
  }

  destroyed() {
    this.detachExternalListeners()
  }
}
